import React from 'react'
import FooterExLinkCardQuickLink from './FooterExLinkCardQuickLink'
import './FooterExLinkCard.css'


function FooterExLinkCard({title}) {
    
    
    return (
        <div className="FooterExLinkItem">
            <div className="FooterTxtTitle">{title}</div>
            <ul className="footerQucLink">
                <FooterExLinkCardQuickLink
                    item = "Explore"
                    path = "/explore"
                />
                <FooterExLinkCardQuickLink
                    item = "Activity"
                    path = "/activity"
                />
                <FooterExLinkCardQuickLink
                    item = "Support"
                    path = "/support"
                />
                
            </ul> 
        </div>
    )
}

export default FooterExLinkCard
